import React from 'react';
import DomainListPage from '../components/domaines/DomainListPage';
import { gandiDomainListAdapter } from '../adapters/domainListAdapters';

const DomaineGandiPage = () => (
  <DomainListPage adapter={gandiDomainListAdapter} />
);

export default DomaineGandiPage;
